import {
  Dashboard as DashboardIcon,
  Inventory2 as ProductsIcon,
  ShoppingCart as OrdersIcon,
  Store as StoreIcon,
  Settings as SettingsIcon,
  Palette as ThemeIcon,
  People as ManagersIcon,
  Business as BranchesIcon,
  Close as CloseIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface AdminSidebarProps {
  user: { email: string; role: string };
  activeTab: string;
  setActiveTab: (tab: string) => void;
  closeSidebar?: () => void;
}

export default function AdminSidebar({ user, activeTab, setActiveTab, closeSidebar }: AdminSidebarProps) {
  const navigate = useNavigate();

  const navItems = [
    { key: 'home', label: 'Home', icon: <HomeIcon />, isExternal: true },
    { key: 'products', label: 'Products', icon: <ProductsIcon /> },
    { key: 'orders', label: 'Orders', icon: <OrdersIcon /> },
    ...(user.role === 'super_admin'
      ? [
          { key: 'branches', label: 'Branches', icon: <BranchesIcon /> },
          { key: 'managers', label: 'Managers', icon: <ManagersIcon /> },
          { key: 'stores', label: 'Stores', icon: <StoreIcon /> },
        ]
      : []),
    { key: 'themes', label: 'Themes', icon: <ThemeIcon /> },
    { key: 'settings', label: 'Settings', icon: <SettingsIcon /> },
  ];

  return (
    <aside className="h-full w-64 bg-white rounded-lg shadow-lg p-4 flex flex-col z-50">
      {/* Mobile close button */}
      {closeSidebar && (
        <div className="flex items-center justify-between md:hidden mb-4">
          <h2 className="text-lg font-semibold">Menu</h2>
          <button onClick={closeSidebar}>
            <CloseIcon className="text-gray-500" />
          </button>
        </div>
      )}

      {/* User info */}
      <div className="mb-6">
        <h2 className="font-bold text-gray-800 mb-1 truncate">{user.email}</h2>
        <p className="text-sm text-gray-500 capitalize">{user.role.replace('_', ' ')}</p>
      </div>

      {/* Navigation */}
      <nav className="space-y-1 flex-1 overflow-auto">
        {navItems.map(({ key, label, icon, isExternal }) => (
          <button
            key={key}
            onClick={() => {
              if (isExternal) {
                navigate('/');
              } else {
                setActiveTab(key);
              }
              if (closeSidebar) closeSidebar();
            }}
            className={`flex items-center gap-3 w-full px-4 py-2 rounded-lg transition-colors text-sm font-medium
              ${
                activeTab === key
                  ? 'bg-primary text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }
            `}
          >
            <span className="text-xl">{icon}</span>
            {label}
          </button>
        ))}
      </nav>
    </aside>
  );
}
